import(/* webpackMode: "eager" */ "/vercel/path0/src/app/viec-lam/page.tsx");
